import React, {Component} from 'react'
import {Dropdown,Modal, Button , Table} from 'react-bootstrap'
import {connect} from 'react-redux'
import loading from '../../assets/loading.svg'
import {filterGroupByCo, selectEwGroup} from '../action/ewGroupActions'
import {selectEwCompany}  from '../action/ewCompanyActions'

class RoleCompany extends Component{

    constructor(props){
        super(props)
        this.state = {search : '', show : false}
    }

   

    toggleShow(){
        this.setState({show : !this.state.show})
    }
    selectCo(co){
        this.setState({selected : co})
    }

 
    render(){

    
        if(this.props.dbCo && !this.props.selected){
            let selected = this.props.cos.Mfrs.find((c)=>{
                if(c['Public Id of Manufacturer'])
                    return c['Public Id of Manufacturer'] == this.props.dbCo
            })
            if(!selected){
                selected = this.props.cos.Dists.find((c)=>{
                    if(c['Public Id of Distributor'])
                        return c['Public Id of Distributor'] == this.props.dbCo
                })
            }

            console.log('selected co', this.props.index, selected)

            this.props.dispatch(selectEwCompany(selected, this.props.index))

            this.props.dispatch(filterGroupByCo(selected['Roles'], this.props.index))
        }

         var filteredMfrs = this.props.cos.Mfrs ? this.props.cos.Mfrs.filter(m=>{
 
            if(this.state.search.length === 0)
                return true
                if(m['Manufacturer Name'] && m['Public Id of Manufacturer'])
             return m['Manufacturer Name'].toLowerCase().includes(this.state.search.toLowerCase()) || m['Public Id of Manufacturer'].includes(this.state.search)
         }) : []

         var filteredDists = this.props.cos.Dists ? this.props.cos.Dists.filter(m=>{

            if(this.state.search.length === 0)
                return true
                if(m['Distributor Name'] && m['Public Id of Distributor'])
             return m['Distributor Name'].toLowerCase().includes(this.state.search.toLowerCase()) || m['Public Id of Distributor'].includes(this.state.search)
         }) : []

         const Ddtoggle = (()=>{
            if(this.props.selected){
                if(this.props.selected['Manufacturer Name']){

                    if(this.props.selected['Manufacturer Name'] == 'IDEA Users')
                    return 'IDEA Users'

                    return this.props.selected['Manufacturer Name'].substring(0, 25) + ' - ' + this.props.selected['Public Id of Manufacturer']
                
                }
                else
                return this.props.selected['Distributor Name'] + ' - ' + this.props.selected['Public Id of Distributor']
               
            }

            return 'Select a Company'
              
         })

        return (
            <div >

<Button disabled ={this.props.loading} onClick={()=>this.toggleShow()}>
<img hidden = {!this.props.loading}  style={{height : '40px'}} src={loading } />
    <Ddtoggle />
</Button>

<Modal show={this.state.show} >
  <Modal.Header>
    
    <br />
        <input onChange={(e)=> {this.setState({search : e.target.value})}} defaultValue={this.state.search} placeholder='Search Companies' style={{ textAlign : 'center',marginLeft : '1px', width : '99%'}} />

  </Modal.Header> 
    <Modal.Body style={{height : '350px', overflow : 'auto'}}>
  
    <Table striped bordered hover>
    <thead>
        <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Type</th>
            <th>Subscription Level</th>
        </tr>
    </thead>
    <tbody style={{overflow : 'auto', height : '350px'}}>
    {filteredMfrs.map((g, index)=>{
          return  <tr style={{cursor : 'pointer'}} onClick={()=>{
            //this.selectCo(g)
            this.props.dispatch(selectEwCompany(g, this.props.index))

           // this.props.dispatch(removeEwGroupSelection())
            //console.log('roles', g['Roles'])
            this.props.dispatch(filterGroupByCo(g['Roles'], this.props.index))
            this.props.dispatch(selectEwGroup(null, this.props.index))

            this.toggleShow()
          }} key={g['Public Id of Manufacturer'] + index} >

          <td>
          {g['Manufacturer Name']}
          </td>

          <td>
          {g['Public Id of Manufacturer']}
          </td>

          <td>
              {g['Manufacturer Name'] == 'IDEA Users' ? 'ALL' : 'MFR'}
          </td>

          <td>
          {g['Manufacturer Subscription Level']}
          </td>

          </tr>
      })}
       {filteredDists.map((g, index)=>{
          return  <tr style={{cursor : 'pointer'}} onClick={()=>{
           // this.selectCo(g)
           this.props.dispatch(selectEwCompany(g, this.props.index))
           this.props.dispatch(filterGroupByCo(g['Roles'], this.props.index))
           this.props.dispatch(selectEwGroup(null, this.props.index))

            this.toggleShow()
          }} key={g['Public Id of Distributor'] + index} >

          <td>
          {g['Distributor Name']}
          </td>

          <td>
          {g['Public Id of Distributor']}
          </td>

          <td>
              Dist
          </td>

          <td>
          {g['Distributor Subscription Level']}
          </td>

          </tr>
      })}
    </tbody>
    </Table>
    </Modal.Body>

<Modal.Footer>
<Button onClick={()=>this.toggleShow()}
    variant='danger'>Cancel</Button>
</Modal.Footer>
</Modal>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => (
    {
    cos: state.acct.ewCo.companies,
    loading : state.acct.ewCo.loading,
    selected : state.acct.ewCo['selected' + ownProps.index]
  });
  


export default connect(mapStateToProps, null, null, { forwardRef: true })(RoleCompany)